<template>
  <div class="list-wrap">
    <div class="title">
      <div class="name">赛事</div>
      <div class="time">时间</div>
      <div class="score">比分</div>
      <div class="long">地图</div>
      <div class="num">R1/R16</div>
      <div class="num">五杀/十杀</div>
      <div class="num"></div>
      <div class="status">胜负</div>
    </div>
    <div class="item" v-for="(item, idx) in list" :key="`${idx}`">
      <div class="name">{{ item.league }}</div>
      <div class="time">{{ item.start_time_int | formatDate }}</div>
      <div class="score">{{ item.home_score }} - {{ item.away_score }}</div>
      <div class="long">{{ item.map_name }}</div>
      <div class="num">
        <img v-if="item.one_pistol" src="../../../assets/images/gaming/first_success-pre.png" alt="">
        <img v-else src="../../../assets/images/gaming/first_success-nor.png" alt="">
        <img v-if="item.sixteen_pistol" src="../../../assets/images/gaming/16_success-pre.png" alt="">
        <img v-else src="../../../assets/images/gaming/16_success-nor.png" alt="">
      </div>
      <div class="num">
        <img v-if="item.is_five" src="../../../assets/images/gaming/five_success-pre.png" alt="">
        <img v-else src="../../../assets/images/gaming/five_success-nor.png" alt="">
        <img v-if="item.is_ten" src="../../../assets/images/gaming/ten_success-pre.png" alt="">
        <img v-else src="../../../assets/images/gaming/ten_success-nor.png" alt="">
      </div>
      <div class="num">
      </div>
      <div class="status">
        <img v-if="item.is_win" src="../../../assets/images/gaming/player-success-icon.png" alt="">
        <img v-else src="../../../assets/images/gaming/player-fail-icon.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: "SmallList",
  props: {
    list: {
      type: Array
    }
  },
  filters: {
    secToMin(sec) {
      // 将秒数除以60，得到分钟数
      let min = sec / 60;
      // 使用 Math.floor 方法向下取整
      min = Math.floor(min);
      const second = sec % 60 < 10 ? '0'  + sec % 60 : sec % 60
      // 返回结果
      return `${min}分${second}秒`;
    },
    formatDate (val) {
      return dayjs(val * 1000).format('YYYY-MM-DD')
    }
  },
}
</script>

<style lang="less" scoped>
.list-wrap {
  .title {
    display: flex;
    height: 44px;
    line-height: 44px;
    background: #FFFDE8;
    font-size: 14px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    text-align: center;
  }
  .item {
    display: flex;
    height: 36px;
    align-items: center;
    box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25);
    text-align: center;
    .status {
      img {
        width: 22px;
        height: 22px;
      }
    }
  }
  .name {
    width: 133px;
  }
  .time {
    width: 133px;
  }
  .score {
    width: 116px;
  }
  .long {
    width: 116px;
    margin-right: 15px;
  }
  .num {
    width: 92px;
    margin-right: 25px;
    display: flex;
    justify-content: center;
    gap: 4px;
    img {
      width: 18px;
      height: 18px;
    }
  }
  .status {
    width: 89px;
  }
}
</style>